import { CountryCode } from './countries';

export const VIDEO_TUTORIALS = {
    ENTRIES: 'https://www.equinetapp.com/support/videotutorials#rec703544117',
    SHOPPING_LISTS:
        'https://www.equinetapp.com/support/videotutorials#rec703569071',
    SCHEDULE: 'https://www.equinetapp.com/support/videotutorials#rec703567848',
} as const;

export const APP_STORE_URLS = {
    APPLE: 'https://apps.apple.com/app/id1459492568',
    GOOGLE_PLAY:
        'https://play.google.com/store/apps/details?id=com.mustad.equinetapp',
} as const;

export const EQUINET_SUPPORT_PAGE_URL = 'https://www.equinetapp.com/support';

interface ExternalUrlConfig {
    readonly support: string;
    readonly faq: string;
    readonly contact: string;
    readonly website: string;
    readonly terms: string;
    readonly privacy: string;
    readonly aboutTeams: string;
}

export interface ExternalUrlsByRegion {
    readonly [CountryCode.unitedStates]: ExternalUrlConfig;
    readonly default: ExternalUrlConfig;
}

const EXTERNAL_URLS: ExternalUrlsByRegion = {
    US: {
        support: 'https://www.equinetapp.com/us/support',
        faq: 'https://www.equinetapp.com/us/frequentlyaskedquestions',
        contact: 'https://www.equinetapp.com/us/contact',
        website: 'https://www.equinetapp.com/us',
        terms: 'https://www.equinetapp.com/us/termsandconditions',
        privacy: 'https://www.equinetapp.com/us/privacypolicy',
        aboutTeams: 'https://www.equinetapp.com/us/aboutequinetteams',
    },
    default: {
        support: 'https://www.equinetapp.com/support',
        faq: 'https://www.equinetapp.com/frequentlyaskedquestions',
        contact: 'https://www.equinetapp.com/contact',
        website: 'https://www.equinetapp.com/',
        terms: 'https://www.equinetapp.com/termsandconditions',
        privacy: 'https://www.equinetapp.com/privacypolicy',
        aboutTeams: 'https://www.equinetapp.com/aboutequinetteams',
    },
} as const;

export type Region = keyof ExternalUrlsByRegion;
export type UrlKey = keyof ExternalUrlConfig;

export const getExternalUrl = (urlKey: UrlKey, region?: string): string => {
    const regionKey = (region as Region | undefined) ?? 'default';
    const regionUrls = EXTERNAL_URLS[regionKey] ?? EXTERNAL_URLS.default;
    return regionUrls[urlKey] ?? EXTERNAL_URLS.default[urlKey];
};

export const getSupportUrl = (region?: string): string =>
    getExternalUrl('support', region);

export const getFaqUrl = (region?: string): string =>
    getExternalUrl('faq', region);

export const getContactUrl = (region?: string): string =>
    getExternalUrl('contact', region);

export const getWebsiteUrl = (region?: string): string =>
    getExternalUrl('website', region);

export const getTermsUrl = (region?: string): string =>
    getExternalUrl('terms', region);

export const getPrivacyUrl = (region?: string): string =>
    getExternalUrl('privacy', region);

export const getAboutTeamsUrl = (region?: string): string =>
    getExternalUrl('aboutTeams', region);

export const PREMIUM_FEATURES_URL =
    'https://www.equinetapp.com/us/features/teams';

export { EXTERNAL_URLS };
